import React, { useState, useEffect } from 'react';
import { db } from '../Components/auth/firebaseConfig';
import { collection, getDocs, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import { useSearch } from '../Components/context/SearchContext'; // Import useSearch
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import SideDrawer from '../Components/newcomponents/SideDrawer';
import { fetchUserGroups, updateUserGroupRole, deleteUserGroup   } from '../DatabaseApis/DBQuery';
import { fetchUserGroupsByTenant } from '../DatabaseApis/DBQuery';
import { getAuth } from 'firebase/auth';
import { query, where } from 'firebase/firestore';
import { getCookie } from '../utils/cookieUtils';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: 'none',
}));

const roles = [
  // { value: 'Super Admin', label: 'Super Admin' },
  { value: 'Admin', label: 'Admin' },
  // { value: 'Operator', label: 'Operator' },
  { value: 'Normal User', label: 'User' },
  // { value: 'Guest', label: 'Guest' },
];

const UserGroups = () => {
  const [userGroups, setUserGroups] = useState([]);
  const [roleMap, setRoleMap] = useState({});
  const [selectedRole, setSelectedRole] = useState({});
  const [isUpdating, setIsUpdating] = useState(null);
  const { searchTerm } = useSearch(); // Use useSearch
  const navigate = useNavigate(); // Use useNavigate

  useEffect(() => {
    const getUserGroups = async () => {
      try {
        // Prefer tenant selected at login for multi-tenant users.
        const sessionUserData = getCookie('userData');
        let tenantId = sessionUserData?.tenantId || '';

        // Fallback if session cookie is unavailable.
        if (!tenantId) {
          const auth = getAuth();
          const currentUser = auth.currentUser;
          if (currentUser && currentUser.email) {
            const usersRef = collection(db, 'users');
            const q = query(usersRef, where('email', '==', currentUser.email));
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
              const userDoc = querySnapshot.docs[0];
              tenantId = userDoc.data().tenantId || '';
            }
          }
        }
        if (!tenantId) return;
        const groups = await fetchUserGroupsByTenant(tenantId);
        setUserGroups(groups);
        const roles = {};
        groups.forEach(group => roles[group.id] = group.accessPermission);
        setRoleMap(roles);
      } catch (error) {
        console.error('Error fetching user groups:', error);
      }
    };
    getUserGroups();
  }, []);

  const handleRoleChange = (id, newRole) => {
    setSelectedRole(prev => ({ ...prev, [id]: newRole }));
  };

 
const handleUpdateRole = async (id) => {
  try {
    const updatedGroup = await updateUserGroupRole(id, selectedRole[id]);
    setRoleMap((prev) => ({ ...prev, [id]: updatedGroup.accessPermission }));
    setIsUpdating(null);
  } catch (error) {
    console.error("Error updating user group role:", error);
  }
};

const handleDelete = async (id) => {
  try {
    await deleteUserGroup(id);
    setUserGroups((prevGroups) => prevGroups.filter((group) => group.id !== id));
  } catch (error) {
    console.error("Error deleting user group:", error);
  }
};
  const handleAddClick = () => {
    navigate('/add-user-group'); // Navigate to the add user group form
  };

  // Filter user groups based on the search term
  const filteredUserGroups = userGroups.filter(group =>
    group.groupName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    group.userGroupId.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box sx={{ marginLeft: '70px' }}>
      <Typography variant="h4" gutterBottom>
        User Groups
      </Typography>
      <SideDrawer/>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>User Group ID</StyledTableCell>
              <StyledTableCell>Group Name</StyledTableCell>
              <StyledTableCell>Access Permission</StyledTableCell>
              <StyledTableCell>Actions</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredUserGroups.map((group) => (
              <TableRow key={group.id}>
                <StyledTableCell>{group.userGroupId}</StyledTableCell>
                <StyledTableCell>{group.groupName}</StyledTableCell>
                <StyledTableCell>
                  {isUpdating === group.id ? (
                    <FormControl fullWidth>
                      <Select
                        value={selectedRole[group.id] || group.accessPermission}
                        onChange={(e) => handleRoleChange(group.id, e.target.value)}
                      >
                        {roles.map(role => (
                          <MenuItem key={role.value} value={role.value}>
                            {role.label}
                          </MenuItem>
                        ))}
                      </Select>
                      <Button onClick={() => handleUpdateRole(group.id)}>Save</Button>
                      <Button onClick={() => setIsUpdating(null)}>Cancel</Button>
                    </FormControl>
                  ) : (
                    roleMap[group.id]
                  )}
                </StyledTableCell>
                <StyledTableCell>
                  <IconButton color="primary" onClick={() => setIsUpdating(group.id)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton color="secondary"  style={{ color: 'red' }} onClick={() => handleDelete(group.id)}>
                    <DeleteIcon />
                  </IconButton>
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
      <IconButton
        color="primary"
        onClick={handleAddClick}
        sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: 'primary.main', color: 'white' }}
      >
        <AddIcon />
      </IconButton>
      </Box>
    </Box>
  );
};

export default UserGroups;
